export default "__VITE_ASSET__COv$IAoj__"